module.exports = __webpack_public_path__ + "img/BS04.16995f52.svg";